var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVialGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vial_grey",
    "data-name": "vial grey",
    xmlns: "http://www.w3.org/2000/svg",
    width: 4.668,
    height: 17.658,
    viewBox: "0 0 4.668 17.658",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_7360",
    "data-name": "Rectangle 7360",
    d: "M0,0H3.237a0,0,0,0,1,0,0V11.979A1.619,1.619,0,0,1,1.619,13.6h0A1.619,1.619,0,0,1,0,11.979V0A0,0,0,0,1,0,0Z",
    transform: "translate(0.715 4.061)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7359",
    "data-name": "Rectangle 7359",
    width: 4.668,
    height: 3.532,
    transform: "translate(0 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVialGrey);
export default __webpack_public_path__ + "static/media/vial_grey.05bbef65.svg";
export { ForwardRef as ReactComponent };